import { render, staticRenderFns } from "./TaskUpdateTitle.vue?vue&type=template&id=d135ea68&scoped=true"
import script from "./TaskUpdateTitle.vue?vue&type=script&lang=js"
export * from "./TaskUpdateTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d135ea68",
  null
  
)

export default component.exports